import calendarFolder from 'owa-service/lib/factory/calendarFolder';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import type SetFolderField from 'owa-service/lib/contract/SetFolderField';

/**
 * Takes the key/value of the property to be updated and returns a SetFolderField.
 * This needs to handle all properties of calendarFolder.
 * TODO: At present this handles updates for a few properties, need to implement the updates as we need them in the UI
 * @param propertyName name of the property to be updated in the calendar folder object
 * @param value Value of the property to be updated
 */
export default function getUpdateForFolderProperty(
    propertyName: string,
    value: any
): SetFolderField {
    switch (propertyName) {
        case 'CharmId':
            return setFolderField({
                Path: propertyUri({ FieldURI: 'Charm' }),
                Folder: calendarFolder({
                    Charm: value,
                }),
            });
        default:
            return null;
    }
}
